import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import type {
  CreateSSHKeyParams,
  ShareSSHKeyParams,
  RevokeSSHKeyParams,
} from "ee/types/sshKeysTypes";

export const fetchSSHKeysInit = () => ({
  type: ReduxActionTypes.FETCH_SSH_KEYS_INIT,
});

export const createSSHKeyInit = (params: CreateSSHKeyParams) => ({
  type: ReduxActionTypes.CREATE_SSH_KEY_INIT,
  payload: params,
});

export const deleteSSHKeyInit = (id: string) => ({
  type: ReduxActionTypes.DELETE_SSH_KEY_INIT,
  payload: { id },
});

export const exportSSHKeyInit = (id: string) => ({
  type: ReduxActionTypes.EXPORT_SSH_KEY_INIT,
  payload: { id },
});

export const importSSHKeyInit = (file: File) => ({
  type: ReduxActionTypes.IMPORT_SSH_KEY_INIT,
  payload: { file },
});

export const shareSSHKeyInit = (params: ShareSSHKeyParams) => ({
  type: ReduxActionTypes.SHARE_SSH_KEY_INIT,
  payload: params,
});

export const revokeSSHKeyInit = (params: RevokeSSHKeyParams) => ({
  type: ReduxActionTypes.REVOKE_SSH_KEY_INIT,
  payload: params,
});

export const openCreateModal = () => ({
  type: ReduxActionTypes.OPEN_SSH_KEY_CREATE_MODAL,
});

export const closeCreateModal = () => ({
  type: ReduxActionTypes.CLOSE_SSH_KEY_CREATE_MODAL,
});

export const openDeleteModal = (id: string) => ({
  type: ReduxActionTypes.OPEN_SSH_KEY_DELETE_MODAL,
  payload: { id },
});

export const closeDeleteModal = () => ({
  type: ReduxActionTypes.CLOSE_SSH_KEY_DELETE_MODAL,
});

export const openShareModal = (id: string) => ({
  type: ReduxActionTypes.OPEN_SSH_KEY_SHARE_MODAL,
  payload: { id },
});

export const closeShareModal = () => ({
  type: ReduxActionTypes.CLOSE_SSH_KEY_SHARE_MODAL,
});

export const openImportModal = () => ({
  type: ReduxActionTypes.OPEN_SSH_KEY_IMPORT_MODAL,
});

export const closeImportModal = () => ({
  type: ReduxActionTypes.CLOSE_SSH_KEY_IMPORT_MODAL,
});

export const setSelectedKeyId = (id: string | null) => ({
  type: ReduxActionTypes.SET_SELECTED_SSH_KEY_ID,
  payload: { id },
});

export const resetSSHKeysState = () => ({
  type: ReduxActionTypes.RESET_SSH_KEYS_STATE,
});
